"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.recipesByCookbookAndSectionIdQuery = void 0;
const client_1 = require("@apollo/client");
const recipeName_1 = require("../fragments/recipeName");
exports.recipesByCookbookAndSectionIdQuery = client_1.gql `
  query RecipesByCookbookAndSectionId($sectionId: String!) {
    recipesByCookbookAndSectionId(sectionId: $sectionId) {
      ...recipeName
    }
  }
  ${recipeName_1.recipeNameFragment}
`;
//# sourceMappingURL=recipesByCookbookAndSectionId.js.map